import React from "react";
import { Link } from "react-router-dom";
import { CCEmptyState } from "@pymblecitizencoders/cc-ui";
import "../components/eventManager/eventManager.css";

export const NoMatch = () => {
	return (
		<div className="em-page" data-surface="page">
			<div className="em-container em-container--narrow">
				<div className="em-panel em-notice-panel" data-surface="card">
					<CCEmptyState
						message="That page could not be found."
						action={<Link to="/home">Back to the event calendar</Link>}
					/>
				</div>
			</div>
		</div>
	);
};
